// extracted by mini-css-extract-plugin
module.exports = {"default-arrows-container":"_7a3fb80146--default-arrows-container--Vy8RU","default-arrows-wrapper":"_7a3fb80146--default-arrows-wrapper--T4sQF"};